export default __webpack_public_path__ + "static/media/fitTokenStr.423c0cec.png";